import { render, staticRenderFns } from "./metrics.vue?vue&type=template&id=0c4cc66c&scoped=true&"
import script from "./metrics.vue?vue&type=script&lang=js&"
export * from "./metrics.vue?vue&type=script&lang=js&"
import style0 from "./metrics.vue?vue&type=style&index=0&id=0c4cc66c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4cc66c",
  null
  
)

export default component.exports